import React from 'react';

import { Button } from 'shadcn/components/ui/Button';
import { ButtonGroup } from 'shadcn/components/ui/ButtonGroup';
import { Card, CardContent } from 'shadcn/components/ui/Card';

import { DECISION_NOT_PICKED, DECISION_PICKED } from './mispickDecisions';

/**
 * @param {Object} props
 * @param {{
 *   sellableItemId: number,
 *   name: string,
 *   slot: number,
 *   external_sku: number|string,
 *   expectedQuantity: number,
 * }} props.item
 * @param {'picked'|'not_picked'|undefined} props.decision
 * @param {(sellableItemId: number, decision: 'picked'|'not_picked') => void} props.onDecisionChange
 */
function MispickUnpickedItemRow({ decision, item, onDecisionChange }) {
    return (
        <li>
            <Card className="py-4">
                <CardContent className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                    <div className="space-y-1">
                        <p className="font-medium leading-none">{item.name}</p>
                        <p className="text-sm text-muted-foreground">
                            SKU {item.external_sku} · Slot {item.slot} · Qty: {item.expectedQuantity}
                        </p>
                    </div>
                    <ButtonGroup aria-label={item.name}>
                        <Button
                            type="button"
                            size="sm"
                            variant={decision === DECISION_PICKED ? 'default' : 'outline'}
                            aria-pressed={decision === DECISION_PICKED}
                            onClick={() => onDecisionChange(item.sellableItemId, DECISION_PICKED)}
                        >
                            Picked
                        </Button>
                        <Button
                            type="button"
                            size="sm"
                            variant={decision === DECISION_NOT_PICKED ? 'default' : 'outline'}
                            aria-pressed={decision === DECISION_NOT_PICKED}
                            onClick={() => onDecisionChange(item.sellableItemId, DECISION_NOT_PICKED)}
                        >
                            Not Picked
                        </Button>
                    </ButtonGroup>
                </CardContent>
            </Card>
        </li>
    );
}

export { MispickUnpickedItemRow };
